import React, { useState, useEffect } from "react";
import Header from "./Pages/Header";
import Sidebar from "./Pages/Sidebar";
import QueryCard from "./Pages/QueryCard";
import QueryFilters from "./Pages/QueryFilters";
import QueryModal from "./Pages/QueryModal";
import Footer from "./Pages/Footer";
import "./Styles/globals.css";
import { useParams } from "react-router-dom";
import HelpResponse from "./Pages/Help";
import ProjectSubmissions from "./Pages/ProjectSubmissions";
import Referrals from "./Pages/Referral";

// Sample data
const initialQueries = [
  {
    id: 1,
    title: "Project Submission Issue",
    category: "Project Submission",
    status: "open",
    priority: "high",
    course: "intro",
    courseName: "Introduction to Qodify",
    createdDate: "Oct 20, 2023",
    description:
      "I'm having trouble submitting my final project. The upload keeps failing at 90% completion. I've tried multiple times with different browsers but the issue persists. The file size is within the limit (25MB).",
    responseCount: 2,
  },
  {
    id: 2,
    title: "Platform Login Issue",
    category: "Project Submission",
    status: "pending",
    priority: "medium",
    course: "advanced",
    courseName: "Advanced Techniques",
    createdDate: "Oct 18, 2023",
    description:
      "I'm unable to log in to the Qodify platform from my mobile device. The app crashes immediately after entering credentials. I've tried reinstalling but the issue persists. My device is Android 12, Samsung Galaxy S21.",
    responseCount: 1,
  },
  {
    id: 3,
    title: "Certificate Request",
    category: "Help",
    status: "resolved",
    priority: "low",
    course: "all",
    courseName: "All Courses",
    createdDate: "Oct 15, 2023",
    description:
      "I've completed the 'Introduction to Qodify' course but haven't received my completion certificate yet. Could you please check the status and let me know when I can expect to receive it?",
    responseCount: 3,
  },
  {
    id: 4,
    title: "Referral Program Inquiry",
    category: "Refferal",
    status: "closed",
    priority: "medium",
    course: "integration",
    courseName: "Integration Methods",
    createdDate: "Oct 10, 2023",
    description:
      "I'd like to refer a friend to the Qodify platform. Can you provide details about the referral program benefits and how the process works? I couldn't find this information in the student portal.",
    responseCount: 4,
  },
];

function StudentProfileMainPage() {
  const [queries, setQueries] = useState(initialQueries);
  const [filteredQueries, setFilteredQueries] = useState(initialQueries);
  const [activeTab, setActiveTab] = useState("all");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    status: "all",
    priority: "all",
    course: "all",
    search: "",
  });

  const { tab } = useParams();

  // Filter queries based on active tab and filters
  useEffect(() => {
    const filtered = queries.filter((query) => {
      const categoryMatch = activeTab === "all" || query.category === activeTab;
      const statusMatch =
        filters.status === "all" || query.status === filters.status;
      const priorityMatch =
        filters.priority === "all" || query.priority === filters.priority;
      const courseMatch =
        filters.course === "all" || query.course === filters.course;
      const searchMatch =
        filters.search === "" ||
        query.title.toLowerCase().includes(filters.search.toLowerCase()) ||
        query.description.toLowerCase().includes(filters.search.toLowerCase());

      return (
        categoryMatch &&
        statusMatch &&
        priorityMatch &&
        courseMatch &&
        searchMatch
      );
    });

    setFilteredQueries(filtered);
  }, [activeTab, filters, queries]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const handleSearchChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      search: value,
    }));
  };

  const handleNewQuery = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmitQuery = (formData) => {
    const newQuery = {
      id: queries.length + 1,
      title: formData.title,
      category: formData.category,
      status: "open",
      priority: formData.priority,
      course: formData.course,
      courseName:
        formData.course === "all"
          ? "All Courses"
          : formData.course === "intro"
          ? "Introduction to Qodify"
          : formData.course === "advanced"
          ? "Advanced Techniques"
          : "Integration Methods",
      createdDate: new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      }),
      description: formData.description,
      responseCount: 0,
    };

    setQueries((prev) => [newQuery, ...prev]);
    setIsModalOpen(false);
    alert(
      "Query submitted successfully! Our support team will respond within 24 hours."
    );
  };

  const handleViewQuery = (query) => {
    alert(`Viewing query: ${query.title}`);
  };

  const handleEditQuery = (query) => {
    alert(`Editing query: ${query.title}`);
  };

  const handleDeleteQuery = (queryId) => {
    if (window.confirm("Are you sure you want to delete this query?")) {
      setQueries((prev) => prev.filter((query) => query.id !== queryId));
    }
  };

  return (
    <div className="student-profile-bg-cont">
      {/* <Header onLogin={handleLogin} onSignup={handleSignup} /> */}

      <main className="student-profile-main">
        <section className="content-area">
          {tab === "help" && <HelpResponse />}
          {tab === "project-submissions" && <ProjectSubmissions />}
          {tab === "referral" && <Referrals />}
        </section>
      </main>

      <QueryModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitQuery}
      />
    </div>
  );
}

export default StudentProfileMainPage;
